// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { TabMenu } from 'primereact/tabmenu';
// import { MenuItem } from 'primereact/menuitem';

// export const LettersTab = (mainTabLabel: any) => {
//     const router = useNavigate();

//     const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';

//     const HRitems: MenuItem[] = [
//         {
//             label: 'Verification Letters',
//             command: () => {
//                 router('/app/letters/ruhs-letter');
//             }
//         },
//         {
//             label: 'Cancellation Letters',
//             command: () => {
//                 router('/app/letters/register-cancellation');
//             }
//         },
//         {
//             label: 'Reminder Letters',
//             command: () => {
//                 router('/app/letters/reminder-college-letter');
//             }
//         },
//         {
//             label: 'Other Letters',
//             command: () => {
//                 router('/app/letters/noc-letter');
//             }
//         }
//     ];

//     const [activeIndex, setActiveIndex] = useState<number>(0);

//     // Convert string to Set
//     const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

//     // Filter HRitems by checking if label exists in assignedMenuSet
//     const filteredHRitems = HRitems.filter((item) => item.label && assignedMenuSet.has(item.label));

//     useEffect(() => {
//         if (filteredHRitems.length > 0 && mainTabLabel) {
//             const foundIndex = filteredHRitems.findIndex((item) => item.label == mainTabLabel.mainTabLabel);
//             setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
//         }
//     }, [filteredHRitems]);
//     return (
//         <>
//             <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />
//         </>
//     );
// };

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';

export const LettersTab = ({ mainTabLabel }: { mainTabLabel: string }) => {
    const router = useNavigate();
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const assignedMenu = localStorage.getItem('assigned_menu') || '';
    const assignedActions = localStorage.getItem('assigned_actions');
    const parsedActions = assignedActions ? JSON.parse(assignedActions) : [];

    const subMenus = [
        {
            label: 'Verification Letters',
            items: [
                { label: 'RUHS Verification Letters', to: '/app/letters/ruhs-letter' },
                { label: 'NIOS Verification Letters', to: '/app/letters/nios-letter' },
                { label: 'University Verification Letters', to: '/app/letters/verification-university' },
                { label: 'Board Verification Letters', to: '/app/letters/verification-board' },
                { label: 'College Verification Letters', to: '/app/letters/verification-college' },
                { label: 'School Verification Letters', to: '/app/letters/verification-school' },
                { label: 'Gujarat Other Councils', to: '/app/letters/gujarat-other-councils' },
            ]
        },
        {
            label: 'Cancellation Letters',
            items: [
                { label: 'Registration Cancellation', to: '/app/letters/register-cancellation' },
                { label: 'Application Cancellation', to: '/app/letters/application-cancellation' },
                { label: 'Warning Letter', to: '/app/letters/warning-letter' },
                { label: 'Submission Letter', to: '/app/letters/submission-letter' },
                { label: 'Wrong Affidavit', to: '/app/letters/wrong-affidavit-letter' },
                { label: 'False&Fake', to: '/app/letters/false-and-fake' }
            ]
        },
        {
            label: 'Reminder Letters',
            items: [
                { label: 'Reminder To College', to: '/app/letters/reminder-college-letter' },
                { label: 'Reminder To School', to: '/app/letters/reminder-school-letter' },
                { label: 'Reminder To Council', to: '/app/letters/reminder-council' },
                { label: 'Reminder To Hospital', to: '/app/letters/reminder-hospital' },
                { label: 'Reminder To Medical', to: '/app/letters/reminder-medical' },
                { label: 'Reminder To University', to: '/app/letters/reminder-university' },
                { label: 'Reminder To Board', to: '/app/letters/reminder-board' },
                { label: 'Reminder To NIOS', to: '/app/letters/reminder-nios' },
                { label: 'Reminder To RUHS', to: '/app/letters/reminder-ruhs' }
            ]
        },
        {
            label: 'Other Letters',
            items: [
                { label: 'NOC Letter', to: '/app/letters/noc-letter' },
                { label: 'Transfer In', to: '/app/letters/transferin' },
                { label: 'Letters To Hospital', to: '/app/letters/practical-training' }
            ]
        },
        {
            label: 'Data Flow',
            items: [
                { label: 'Data Flow Letter', to: '/app/letters/data-flow' },
            ]
        }
    ];

    const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

    const getFirstAccessibleSubItem = (tabLabel: string): string | null => {
        const subGroup = subMenus.find((group) => group.label === tabLabel);
        if (!subGroup) return null;

        const action = parsedActions.find((a: any) => a.menu === tabLabel);
        if (!action) return null;

        for (const subItem of subGroup.items) {
            if (typeof action === 'object' && action[subItem.label] === 1) {
                return subItem.to;
            }
        }
        return null;
    };

    const hasSubItemAccess = (groupLabel: string): boolean => {
        const group = subMenus.find((g) => g.label === groupLabel);
        if (!group) return false;

        const action = parsedActions.find((a: any) => a.menu === groupLabel);
        if (!action) return false;

        return group.items.some((item) => action[item.label] === 1);
    };

    const filteredHRitems: MenuItem[] = subMenus
        .filter((group) => {
            return assignedMenuSet.has(group.label) || hasSubItemAccess(group.label);
        })
        .map((group) => {
            const firstAccessible = getFirstAccessibleSubItem(group.label);
            return {
                label: group.label,
                command: () => {
                    if (firstAccessible) {
                        router(firstAccessible);
                    }
                }
            };
        });

    useEffect(() => {
        if (filteredHRitems.length > 0 && mainTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label === mainTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [filteredHRitems]);

    return <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />;
};
